'use client';

import useProduct from '@/contexts/ProductProvider';
import { checkDeliveryAndStock } from '@/services/ecommerce/utils/helper';

const WrapperStock = () => {
	const { selectedVariant, product, loading } = useProduct();

	const { stock } = checkDeliveryAndStock(product, selectedVariant);

	return (
		<>
			{!loading && !stock && (
				<div className='py-10'>
					<div className='d-flex items-center gap-5'>
						<div
							style={{
								height: 10,
								width: 10,
								borderRadius: '50%',
								backgroundColor: '#FD6A6A'
							}}></div>
						<div className='text-error fw-500 text-14'>Out of Stock</div>
					</div>
					<div className='text-orange fw-400 text-16 mt-5'>
						Currently unavailable, please request or choose another variant.
					</div>
				</div>
			)}
		</>
	);
};

export default WrapperStock;
